/**
 * @generated SignedSource<<3dcb473468fc2025276306038af9a0e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ApplyAssigneesBulkActionIssueFragment$data = {
  readonly assignedActors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"AssigneePickerSharedAssignee">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly id: string;
  readonly repository: {
    readonly databaseId: number | null | undefined;
    readonly isArchived: boolean;
    readonly isPrivate: boolean;
  };
  readonly " $fragmentType": "ApplyAssigneesBulkActionIssueFragment";
};
export type ApplyAssigneesBulkActionIssueFragment$key = {
  readonly " $data"?: ApplyAssigneesBulkActionIssueFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApplyAssigneesBulkActionIssueFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ApplyAssigneesBulkActionIssueFragment"
};

(node as any).hash = "bf89051fe20d80d2d3307cbae57ac84e";

export default node;
